<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title primary-title>
				<v-btn icon @click="back()">
					<v-icon>mdi-arrow-left</v-icon>
				</v-btn>
				{{ coupon.name }}
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 md4>
						{{ $t("Description") }}:
						{{ coupon.description }}
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
		<p>&nbsp;</p>
		<v-flex xs12 md12>
			<v-card>
				<v-card-title primary-title> Topup History </v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-list>
						<v-list-item-group color="primary">
							<v-list-item v-for="(customers, index) in customers" :key="index">
								<v-list-item-icon>{{ $t("Customer") }} :
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title><strong>{{
									customers.display_name
									}}</strong></v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-item-group>
						<v-divider></v-divider>
						<v-list-item-group color="primary">
							<v-list-item v-for="(customers, index) in customers" :key="index">
								<v-list-item-icon>{{ $t("label.reservations_count") }} :
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title><strong>{{
									customers.reservations_count
									}}</strong></v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-item-group>
						<v-divider></v-divider>
						<v-list-item-group color="primary">
							<v-list-item v-for="(topups, index) in topups" :key="index">
								<v-list-item-icon>{{ $t("label.created_at") }} :
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title><strong>{{
									topups.created_at
									}}</strong></v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-item-group>
						<v-divider></v-divider>
						<v-list-item-group color="primary">
							<v-list-item v-for="(topups, index) in topups" :key="index">
								<v-list-item-icon>{{ $t("Amount") }} :
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title><strong>{{
									topups.amount
									}}</strong></v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-item-group>
						<v-divider></v-divider>
						<v-list-item-group color="primary">
							<v-list-item v-for="(topups, index) in topups" :key="index">
								<v-list-item-icon>{{ $t("Payment Method") }} :
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title><strong>{{
									topups.payment_method_code
									}}</strong></v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-item-group>
						<v-divider></v-divider>
						<v-list-item-group color="primary">
							<v-list-item v-for="(topups, index) in topups" :key="index">
								<v-list-item-icon>{{ $t("label.payment_status") }} :
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title><strong>{{
									topups.payment_status
									}}</strong></v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-item-group>
						<v-divider></v-divider>
					</v-list>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-container>
</template>

<script>
export default {
	props: ["coupon", "topups", "customers"],
	data() {
		return {};
	},

	methods: {
		back() {
			window.history.back();
		}
	}
};
</script>